// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mk-2";
export var interactiveWrapper = "_mk-0";
export var shippingHoverPreview = "_mk-4";
export var summaryBadgeTrigger = "_mk-1";
export var widgetHoverPreviewList = "_mk-3";
export var widgetPreviewScale = "_mk-5";